var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2012 -85 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1997.7244 -78.1314C-1998.7279 -78.1314 -1999.6311 -77.7299 -2000.3337 -77.0275C-2001.0361 -76.3249 -2001.4375 -75.4217 -2001.4375 -74.5186C-2001.4375 -72.5114 -1999.7314 -70.9056 -1997.7244 -70.9056C-1996.7207 -70.9056 -1995.8175 -71.3071 -1995.115 -72.0096C-1994.4126 -72.7121 -1994.011 -73.6153 -1994.011 -74.5186C-1993.9108 -76.5257 -1995.6168 -78.1314 -1997.7244 -78.1314Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1993.8103 -70.8052C-1994.011 -71.006 -1994.4126 -71.006 -1994.7136 -70.8052C-1994.7136 -70.8052 -1997.7244 -68.497 -2000.4341 -70.8052C-2000.7351 -71.006 -2001.0361 -71.006 -2001.3374 -70.8052C-2001.4375 -70.7049 -2004.0469 -68.2962 -2004.1472 -63.5794C-2004.1472 -63.3787 -2004.0469 -63.178 -2003.9465 -63.0777C-2003.8462 -62.9774 -2003.6455 -62.8769 -2003.4448 -62.8769L-1992.0039 -62.8769C-1991.6025 -62.8769 -1991.3014 -63.178 -1991.3014 -63.5794C-1991.3014 -63.7801 -1991.201 -68.196 -1993.8103 -70.8052Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -1997.7243,
    cy: -70.5043,
    rx: 12.8459,
    ry: 12.8459,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.c1d72fa4796a9298970a9fcd6a131721.svg";
export { ForwardRef as ReactComponent };